import type { FC } from 'react';

import type { AvatarData } from '@/helpers/avatar';
import { getCDNImageUrl } from '@/helpers/cdn';

import { ScAvatar } from './styled';

export const Avatar: FC<AvatarData> = ({ src, alt, isSelected, ...props }) => (
  <ScAvatar
    alt={alt}
    className={isSelected ? 'selected' : ''}
    src={src && getCDNImageUrl(src)}
    {...props}
  />
);
